import axios from "axios";

const searchFetchRequest = (q, p) => {
  return {
    type: "SEARCH_FETCH_REQUEST",
    payload: { q, p },
  };
};

const searchFetchSuccess = (movie) => {
  return {
    type: "SEARCH_FETCH_SUCCESS",
    payload: movie,
  };
};

const searchFetchFailure = (error) => {
  return {
    type: "SEARCH_FETCH_FAILURE",
    payload: error,
  };
};

const searchFetch = ({ q, p }) => {
  return (dispatch) => {
    let query = dispatch(searchFetchRequest(q, p)).payload;
    axios({
      method: "GET",
      url: q
        ? `/movies?q=${query.q}&page=1`
        : p
        ? `/movies?q=${query.q}&page=${query.p}`
        : `/movies`,
    })
      .then((response) => {
        const movie = response.data;
        dispatch(searchFetchSuccess(movie));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(searchFetchFailure(errorMsg));
      });
  };
};

export default searchFetch;
